module.exports = __webpack_public_path__ + "img/dashboard_new_custom_order.28fd3fb.png";